import React from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import get from 'lodash/get';
import map from 'lodash/map';
import Form from '../../newClient/form';
import styled from 'styled-components';

const formatDate = 'DD/MM/YYYY';

export const Warranty = ({ values }) => {
  const applications = get(values, 'data.applications', []);
  const isEquivalentToTwo = applications.length === 2;

  return (
    <>
      {console.log('values', values.data.applications)}
      <div className="row">
        <div className="col-12 ViewOrEdit">
          <div>
            <strong>
              <FormattedMessage id="Código de garantía:" />
            </strong>
            <span>{get(values, 'code', '-')}</span>
          </div>
          <div className="kt-space-20" />
          <div>
            <strong>
              <FormattedMessage id="Fecha de creación:" />
            </strong>
            <span>{moment(get(values, 'created', '')).format(formatDate)}</span>
          </div>
          <div className="kt-space-20" />
          <div className="row">
            {/* <div className="col-12 ViewOrEdit">
              <div>
                <strong>
                  <FormattedMessage id="Fecha de vencimiento lámina 1" />
                </strong>
                <span>
                  {moment(applications[0].expires).format(formatDate)}
                </span>
              </div>
              <div className="kt-space-20" />
              {isEquivalentToTwo && (
                <div>
                  <strong>
                    <FormattedMessage id="Fecha de vencimiento lámina 2" />
                  </strong>
                  <span>
                    {moment(applications[1].expires).format(formatDate)}
                  </span>
                </div>
              )}
            </div> */}
            {map(applications, (application, index) => (
              <div key={index} className="col-12 ViewOrEdit p-0">
                <div className="">
                  <strong>
                    <FormattedMessage
                      id={`Fecha de vencimiento lámina ${index + 1}`}
                    />
                  </strong>
                  <span>{moment(application.expires).format(formatDate)}</span>
                </div>
                <div className="kt-space-20" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Warranty;
